import { __read, __spread } from "tslib";
import { parseColor } from '../utils/parseColor';
import { doAlpha } from './opacity';
/**
 * This is the new version palette, support five layer types palette color get,
 * ! Not support opacity, please use `setOpacity` to do that,
 * ! like `setOpacity(palette2('neutral', 'b05'), '80')`
 * @param obj main color
 * @param prop1 sub
 * @param prop2 sub
 * @param prop3 sub
 * @param prop4 sub
 */
function palette2(category) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return getPaletteColor.apply(void 0, __spread([category], keys));
}
function getPaletteColor() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a = __read(args), category = _a[0], keys = _a.slice(1);
    return function (_a) {
        var theme = _a.theme;
        var colorMap = theme.palette[category];
        if (!colorMap) {
            // * that means that just want to use normal value, like a string with rgba or #FFFF or white...
            return category;
        }
        if (typeof colorMap === 'string') {
            return colorMap;
        }
        return keys.reduce(function (acc, curr, i) {
            // if type is the latest one, check is that to be number
            if (i === keys.length - 1) {
                if (typeof curr === 'number') {
                    return doAlpha(acc, curr, theme);
                }
            }
            return acc == null ? '' : acc[curr];
        }, colorMap);
    };
}
function getParsePaletteColor(color, defaultColor, useMain) {
    if (useMain === void 0) { useMain = true; }
    var args = parseColor(color, defaultColor, useMain);
    if (!args) {
        return function () { return null; };
    }
    if (typeof args === 'string') {
        return function () { return args; };
    }
    if (typeof args === 'function') {
        return args;
    }
    return getPaletteColor.apply(void 0, __spread(args));
}
export { getParsePaletteColor, palette2 };
